import { Box, CircularProgress, Grid, Typography } from "@mui/material"
import { useState, useEffect } from "react";
import CardSearchNav from "../card/CardSearchNav";
import ConsultasService from "../../services/consultas.service";
import SinResultados from "./SinResultados";
import SearchLoading from "./SearchLoading";

const TabConsultas = ({textSearch,handleClose}) => {
    const [options, setOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const handleSearchConsultas = async() => {
        if(textSearch?.length >= 2){
            setIsLoading(true);
            await ConsultasService.getAll({textSearch}).then((data)=>{
                console.log({data})
                if(data?.length > 0){
                    setOptions(
                        data?.map((item) =>{
                            if(item?.contactoCuenta_con){
                                return {
                                    ...item,
                                    tituloCard: `#${item?.id_con} - ${item?.nombreContacto_con}`,
                                    descripCard: `N° CUENTA: ${item?.contactoCuenta_con} - Plan: ${item?.planConsulta_con || '-'} - Obs: ${item?.observaciones_con ? item?.observaciones_con?.slice(0, 25) + '...' : '-'}`,
                                    empresaCard: 'NUBICOM',
                                    keyCard: `${item?.contactoCuenta_con}Consulta`
                                }
                            }
                            return {
                                ...item,
                                tituloCard: `#${item?.id_con} - ${item?.nombreContacto_con}`,
                                descripCard: `Plan: ${item?.planConsulta_con || '-'} - Obs: ${item?.observaciones_con ? item?.observaciones_con?.slice(0, 25) + '...' : '-'}`,
                                empresaCard: 'NUBICOM',
                                keyCard: `${item?.contactoId_con}Consulta`
                            }
                        })
                    )
                }else{
                    setOptions([])
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
        }
    };

    useEffect(() => {
        const delayWrite = setTimeout(() => {
            handleSearchConsultas()
        }, 500)
        return () => clearTimeout(delayWrite)
    }, [textSearch])
    return (
        <Grid container>
            { !isLoading ? (
                <>
                    {options && options?.length > 0 ? (
                        options?.map((option)=>(
                            <Grid item xs={12} key={`${option?.keyCard}c`}>
                                <CardSearchNav
                                    item={option}
                                    descripcion={option?.descripCard}
                                    titulo={option?.tituloCard}
                                    key={option?.keyCard}
                                    onCLoseModal={handleClose}
                                    textSearch={textSearch}
                                />
                            </Grid>
                        ))
                    ):(
                        <Grid item xs={12} key='sinPotCli'>
                            <SinResultados />
                        </Grid>
                    )}
                </>
            ):(
                <Grid item xs={12} key='circletabpotcont'>
                    <SearchLoading />
                </Grid>
            )}
        </Grid>
    )
}

export default TabConsultas